import { inject, Pipe, PipeTransform } from '@angular/core';
import { ImageOptimisePreset } from '@rma/generic/core/images';
import { ImageOptimiseService } from '../image-optimise-service/image-optimise.service';

@Pipe({
  name: 'rmaOptimiseImage',
  standalone: true,
})
export class ImageOptimisePipe implements PipeTransform {
  private readonly imageOptimiseService = inject(ImageOptimiseService);

  public transform(value: string | undefined | null, params: ImageOptimisePreset = 'Fallback'): string {
    return this.imageOptimiseService.getFromPreset(value, params);
  }
}
